import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui'
import { isFunction } from 'lodash-es'
import logger from '../logger'

// ////////////////////////////////
// Element Animation Transition //
// ////////////////////////////////

export default {
  init() {
    logger('init ExpandTransition', 'debug')()
  },
  expand(primaryEl, cb, options = {}) {
    // target all DOM nodes
    const $primaryEl = this.root.querySelector(primaryEl)
    const DURATION = options.duration || 250
    $primaryEl.style.setProperty('height', 'auto')
    $primaryEl.style.setProperty('opacity', 0)

    const newElementHeight = $primaryEl.offsetHeight
    $primaryEl.style.setProperty('height', 0)

    // animate the parent to the new height
    const primarySequence = [{
      e: $primaryEl,
      p: {
        height: newElementHeight,
        opacity: 1,
      },
      o: {
        duration: DURATION,
        easing: 'easeInOutQuint',
        complete: () => {
          $primaryEl.style.setProperty('height', 'auto')
          if (isFunction(cb)) cb.call(this)
        },
      },
    }]

    Velocity.RunSequence(primarySequence)
  },
  expandAnimation(primaryEl, cb, options = {}) {
    // target all DOM nodes
    const $primaryEl = this.root.querySelector(primaryEl)

    $primaryEl.style.setProperty('height', 0)
    $primaryEl.style.setProperty('opacity', 0)

    this.expand(primaryEl, cb, options)
  },
}
